import { Injectable } from '@angular/core';
import { Configuration } from 'src/app/shared/models/configuration.model';
import { AuthConfig } from 'angular-oauth2-oidc';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable()
export class AppConfigService {

  authConfig: AuthConfig;
  configuration: Configuration;

  constructor(private http: HttpClient) { }

    setConfiguration(): Promise<Configuration> {
        return new Promise((resolve, reject) => {
            const path = environment.configurationPath;
            this.http.get(path).toPromise().then((response: any) => {
                this.configuration = response;
                return resolve(this.configuration);
            }).then(() => resolve(this.configuration))
                .catch(() => reject());
        });
    }

  setupAuthConfig(configuration: Configuration): AuthConfig {
    this.configuration = configuration;
    return this.authConfig = new AuthConfig({
      issuer: this.configuration.authConfiguration.issuer,
      clientId: this.configuration.authConfiguration.clientId,
      resource: this.configuration.authConfiguration.resource,
      redirectUri: this.configuration.authConfiguration.redirectUri,
      scope: this.configuration.authConfiguration.scope,
      responseType: this.configuration.authConfiguration.responseType,
      requestAccessToken: this.configuration.authConfiguration.requestAccessToken,
      oidc: this.configuration.authConfiguration.oidc,
      loginUrl: this.configuration.authConfiguration.loginUrl,
      tokenEndpoint: this.configuration.authConfiguration.tokenEndpoint,
      postLogoutRedirectUri: this.configuration.authConfiguration.postLogoutRedirectUri
    });
  }
}
